
import { Box, SxProps, Theme } from "@mui/material";

export const TAB_CONTENT_MAX_HEIGHT = 'calc(100vh - 220px)'

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    scrollable?: boolean;
    maxHeight?: string | number;
    sx?: SxProps<Theme>;
  }

const CustomTabPanel = (props: TabPanelProps) => {
    const { children, value, index, scrollable = false, maxHeight = TAB_CONTENT_MAX_HEIGHT, sx, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box
            sx={{
              marginTop: '20px',
              ...(scrollable ? {
                maxHeight,
                overflowY: 'auto',
                overflowX: 'hidden',
                pr: 0.5,
                scrollbarWidth: 'thin',
                '&::-webkit-scrollbar': { width: 6 },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'rgba(0,0,0,0.2)',
                  borderRadius: 3,
                },
              } : {}),
              ...sx,
            }}
          >
            {children}
          </Box>
        )}
      </div>
    );
  }

  export { CustomTabPanel }